import React from 'react';
import {
  FeedbackTriggerLibraryAccessContext,
  FeedbackTriggerLibraryContext,
  FeedbackTriggerLibraryTagContext,
  FeedbackTriggerType,
  LibraryAccessType,
} from 'records/FeedbackTrigger';
import LibraryContextView from 'components/triggers/rule-context/LibraryContextView';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {BookmarkIcon} from '@components/icon/BookmarkIcon';

class LibraryContext extends React.Component {
  constructor(props) {
    super(props);

    this.libraryTypeChanged = this.libraryTypeChanged.bind(this);
    this.getLibraryContext = this.getLibraryContext.bind(this);
    this.getLibraryContextIndex = this.getLibraryContextIndex.bind(this);
    this.removeLibraryContext = this.removeLibraryContext.bind(this);
    this.updateSelectionVisible = this.updateSelectionVisible.bind(this);
    // to hide context button if user popup displayed
    this.state = {
      userContextSelected: false,
    };
  }

  getLibraryContext() {
    const libraryTypes = [
      FeedbackTriggerType.LIBRARY_ACCESS,
      FeedbackTriggerType.LIBRARY_TAG,
      FeedbackTriggerType.ADDS_TO_LIBRARY,
    ];
    return this.props.context.matchAll.find(item => libraryTypes.includes(item.type));
  }

  removeLibraryContext() {
    const index = this.getLibraryContextIndex();
    // default non-specific library (ANY_LIBRARY)
    this.props.contextChange(
      this.props.context.setIn(['matchAll', index], new FeedbackTriggerLibraryAccessContext())
    );
  }

  updateSelectionVisible(fn) {
    this.setState({
      userContextSelected: fn(this.state.userContextSelected),
    });
  }

  getLibraryContextIndex() {
    const libraryContext = this.getLibraryContext();
    return this.props.context.matchAll.indexOf(libraryContext);
  }

  libraryTypeChanged(context) {
    // eslint-disable-next-line
    switch (context.type) {
      case LibraryAccessType.LIBRARY_I_CAN_VIEW:
      case LibraryAccessType.LIBRARY_I_ADMIN:
      case LibraryAccessType.LIBRARY_I_CREATED:
      case LibraryAccessType.ANY_LIBRARY:
        this.props.contextChange(
          this.props.context.setIn(
            ['matchAll', this.getLibraryContextIndex()],
            new FeedbackTriggerLibraryAccessContext({
              matching: context.type,
            })
          )
        );
        break;
      case FeedbackTriggerType.ADDS_TO_LIBRARY:
        this.props.contextChange(
          this.props.context.setIn(
            ['matchAll', this.getLibraryContextIndex()],
            new FeedbackTriggerLibraryContext({
              library_id: context.value,
            })
          )
        );
        break;
      case FeedbackTriggerType.LIBRARY_TAG:
        this.props.contextChange(
          this.props.context.setIn(
            ['matchAll', this.getLibraryContextIndex()],
            new FeedbackTriggerLibraryTagContext({
              tag_name: context.value,
            })
          )
        );
        break;
    }
  }

  render() {
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const libraryContext = this.getLibraryContext();
    const {userContextSelected} = this.state;
    const narrow =
      usersEmpty &&
      !userContextSelected &&
      (!libraryContext ||
        (libraryContext.type === FeedbackTriggerType.LIBRARY_ACCESS &&
          libraryContext.matching === LibraryAccessType.ANY_LIBRARY));
    return (
      <div className="context-container">
        <SmartAlertContextTitle icon={BookmarkIcon} onClose={this.props.removeContext}>
          they added the call to a library
        </SmartAlertContextTitle>
        <div className={narrow && 'initial-options'}>
          {renderEmbeddedContent()}
          {showContextButton && (
            <LibraryContextView
              context={libraryContext}
              updateSelectionVisible={this.updateSelectionVisible}
              selectionVisible={userContextSelected}
              removeItem={this.removeLibraryContext}
              saveSelection={this.libraryTypeChanged}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(LibraryContext);
